import { render, staticRenderFns } from "./KellnerrufErfolgreich.vue?vue&type=template&id=545f6e44&scoped=true"
import script from "./KellnerrufErfolgreich.vue?vue&type=script&lang=js"
export * from "./KellnerrufErfolgreich.vue?vue&type=script&lang=js"
import style0 from "./KellnerrufErfolgreich.vue?vue&type=style&index=0&id=545f6e44&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545f6e44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('545f6e44')) {
      api.createRecord('545f6e44', component.options)
    } else {
      api.reload('545f6e44', component.options)
    }
    module.hot.accept("./KellnerrufErfolgreich.vue?vue&type=template&id=545f6e44&scoped=true", function () {
      api.rerender('545f6e44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/KellnerrufErfolgreich.vue"
export default component.exports